module.exports = __webpack_public_path__ + "static/media/s_v9_t1_1.fa0f80fd.mp3";